// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  'Don’t show this again for this certification': 'CONSULT_DONT_SHOW_LABEL',
  Close: 'CloseLabel',
};
